module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Schedule","usage":"Statement of usage"},"et":{"title":"Schedule","usage":"Statement of usage"},"ru":{"title":"Schedule","usage":"Statement of usage"}}')
  delete Component.options._Ctor
}
